/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DeleteAiScanTargetRequestBody = {
  /**
   * Id of the target to remove.
   */
  id: string;
};

/** @internal */
export type DeleteAiScanTargetRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const DeleteAiScanTargetRequestBody$outboundSchema: z.ZodMiniType<
  DeleteAiScanTargetRequestBody$Outbound,
  DeleteAiScanTargetRequestBody
> = z.object({
  id: z.string(),
});

export function deleteAiScanTargetRequestBodyToJSON(
  deleteAiScanTargetRequestBody: DeleteAiScanTargetRequestBody,
): string {
  return JSON.stringify(
    DeleteAiScanTargetRequestBody$outboundSchema.parse(
      deleteAiScanTargetRequestBody,
    ),
  );
}
